module.exports = __webpack_public_path__ + "static/media/flask-line.6fa5d17d.svg";